(function () {
    'use strict';

    // Drop-in replacement for a <select> whose options are filtered by a search box.
    // The value goes through ngModel, so ng-change, ng-required and form validation work as on a <select>.
    // Usage:
    //   <searchable-select ng-model="order.DiscountId"
    //                      items="discounts"
    //                      item-label="item.InternalName"   (evaluated with `item` as local)
    //                      item-value="Id"                  (optional, defaults to "Id")
    //                      is-disabled="isLocked"           (optional)
    //                      ng-change="onDiscountChanged()">
    //   </searchable-select>
    var component = {
        templateUrl:
            'app/js/components/controls/searchable-select-component/searchable-select.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmSS",
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            items: '<',
            itemLabel: '&',
            itemValue: '@',
            placeholder: '@',
            isDisabled: '<?'
        }
    };

    iteroComponents.component('searchableSelect', component);

    controller.$inject = ['$element', '$timeout', 'gettextCatalog'];

    function controller($element, $timeout, gettextCatalog) {
        var ctrl = this;
        var wasOpen = false;

        ctrl.isOpen = false;
        ctrl.search = '';
        // Options shown in the open dropdown as { value, label, item }; labels are computed once per search
        ctrl.filtered = [];
        // -1 is the "Select" entry that clears the value; it is only shown while the search is empty
        ctrl.activeIndex = -1;
        ctrl.selected = null;
        ctrl.selectedValue = null;

        ctrl.$onInit = function () {
            ctrl.ngModelCtrl.$render = updateSelected;
        };

        ctrl.$onChanges = function (changes) {
            if (changes.items) {
                updateSelected();
                if (ctrl.isOpen) {
                    ctrl.applySearch();
                }
            }
        };

        // uib-dropdown's on-toggle only fires once its open/close animation promise resolves, which is unreliable
        // when the dropdown is reopened quickly, so the transitions are detected here instead.
        ctrl.$doCheck = function () {
            if (ctrl.isOpen !== wasOpen) {
                wasOpen = ctrl.isOpen;
                if (ctrl.isOpen) {
                    onOpen();
                } else {
                    onClose();
                }
            }
        };

        ctrl.placeholderText = function () {
            return ctrl.placeholder || gettextCatalog.getString('Select');
        };

        // Evaluated live rather than cached, because a label can change after selection (e.g. a product override name)
        ctrl.selectedText = function () {
            return ctrl.selected ? label(ctrl.selected) : ctrl.placeholderText();
        };

        // Every whitespace separated term has to occur in the label, in any order and case.
        ctrl.applySearch = function () {
            var terms = (ctrl.search || '').toLowerCase().split(/\s+/).filter(function (term) {
                return term.length > 0;
            });

            ctrl.filtered = [];
            (ctrl.items || []).forEach(function (item) {
                var text = label(item);
                var lowerText = text.toLowerCase();
                var matches = terms.every(function (term) {
                    return lowerText.indexOf(term) !== -1;
                });
                if (matches) {
                    ctrl.filtered.push({ value: valueOf(item), label: text, item: item });
                }
            });
            ctrl.activeIndex = ctrl.search ? 0 : -1;
        };

        ctrl.select = function (option) {
            var value = option ? option.value : null;

            if (normalize(value) !== normalize(ctrl.ngModelCtrl.$viewValue)) {
                ctrl.ngModelCtrl.$setViewValue(value);
                updateSelected();
            }
            ctrl.isOpen = false;
        };

        ctrl.onKeydown = function (event) {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    moveActive(1);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    moveActive(-1);
                    break;
                case 'Enter':
                    // Never submit the surrounding form from the search box.
                    event.preventDefault();
                    if (ctrl.activeIndex === -1 && !ctrl.search) {
                        ctrl.select(null);
                        focusToggle();
                    } else if (ctrl.filtered[ctrl.activeIndex]) {
                        ctrl.select(ctrl.filtered[ctrl.activeIndex]);
                        focusToggle();
                    }
                    break;
                case 'Tab':
                    ctrl.isOpen = false;
                    break;
            }
        };

        function onOpen() {
            ctrl.search = '';
            ctrl.applySearch();

            for (var i = 0; i < ctrl.filtered.length; i++) {
                if (ctrl.filtered[i].item === ctrl.selected) {
                    ctrl.activeIndex = i;
                    break;
                }
            }

            $timeout(function () {
                $element[0].querySelector('.searchable-select-search').focus();
                scrollActiveIntoView();
            });
        }

        function onClose() {
            ctrl.search = '';
            ctrl.filtered = [];
        }

        function updateSelected() {
            var value = ctrl.ngModelCtrl.$viewValue;

            ctrl.selected = null;
            ctrl.selectedValue = null;
            if (normalize(value) === null || !ctrl.items) {
                return;
            }
            for (var i = 0; i < ctrl.items.length; i++) {
                if (valueOf(ctrl.items[i]) === value) {
                    ctrl.selected = ctrl.items[i];
                    ctrl.selectedValue = value;
                    return;
                }
            }
        }

        function valueOf(item) {
            return item ? item[ctrl.itemValue || 'Id'] : null;
        }

        function label(item) {
            var text = ctrl.itemLabel({ item: item });
            return text === undefined || text === null ? '' : String(text);
        }

        // An untouched model is undefined, a cleared one null: both mean "nothing selected"
        function normalize(value) {
            return value === undefined ? null : value;
        }

        function moveActive(step) {
            var minIndex = ctrl.search ? 0 : -1;
            var maxIndex = ctrl.filtered.length - 1;
            if (maxIndex < minIndex) {
                return;
            }
            ctrl.activeIndex = Math.min(Math.max(ctrl.activeIndex + step, minIndex), maxIndex);
            $timeout(scrollActiveIntoView);
        }

        function scrollActiveIntoView() {
            var active = $element[0].querySelector('.searchable-select-options li.active');
            if (active && active.scrollIntoView) {
                active.scrollIntoView({ block: 'nearest' });
            }
        }

        function focusToggle() {
            $timeout(function () {
                $element[0].querySelector('.searchable-select-toggle').focus();
            });
        }
    }
})();
